import { Component, HostListener, OnInit } from '@angular/core';
import { IThirdNavCollapsibleElement } from 'src/app/common-page-components/third-nav-tab-component/third-nav-tab-component.component';
import { LoadDrupalLangService } from '../../common-page-components/services/load-drupal-lang.service';
import { ActivatedRoute, NavigationEnd, Router, NavigationStart } from '@angular/router';
import { BaseComponentComponent } from '../../library/components/components/common/base-component/base-component.component';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-bootstrap-ranking-tabs',
  templateUrl: './bootstrap-ranking-tabs.component.html',
  styleUrls: ['./bootstrap-ranking-tabs.component.scss']
})
export class BootstrapRankingTabsComponent extends BaseComponentComponent implements OnInit {

  /**
   * Routes to bind to and make a substitution in the panel
   *
   * @type {Array<IThirdNavCollapsibleElement>}
   * @memberof BootstrapRankingTabsComponent
   */
  routes: Array<IThirdNavCollapsibleElement> = [
    { name: "world_ranking", route: this.getTranslatedRoutes("world-ranking") },
    { name: 'continental-ranking', route: this.getTranslatedRoutes('continental-ranking')},
    { name: "world_cup", route: this.getTranslatedRoutes("world-cup-ranking") },
    { name: "indoor_series", route: this.getTranslatedRoutes("events/indoor/elite-ranking"), external:true },
    { name: "prize_for_precision", route: this.getTranslatedRoutes("prize-precision") },
  ];

  /**
   * The title of the panel.
   *
   * @memberof BootstrapRankingTabsComponent
   */
  title = 'SanlidaWorldRanking';
  preTitle = 'Statistics';
  headerImage = '../../../modules/custom/wa_angular/app/assets/images/banner-world-ranking.jpg';
  constructor(protected drupàlLang: LoadDrupalLangService, protected router: Router, private titleService: Title) {
    super();
    const routes = window.location.href.split('?')[0].split('/');
    const lastSegment = this.getTranslatedRoutes(routes[routes.length - 1]);
    this.manageHeaderChanges(lastSegment);
  }

  get activeRoute() {
    const activeRoute = this.router.url.split('?')[0]
    if (activeRoute === '/rankings/world-cup-ranking' || activeRoute === '/rankings/prize-precision') {
      return 'none';
    }
    return 'block';
  }

  /**
   * A method for manage the header path changes.
   *
   * @param {string} path the last path after split the '/' character.
   * @memberof BootstrapRankingTabsComponent
   */
  manageHeaderChanges(path: string) {
    switch (path) {
      case 'continental-ranking':
        this.title = 'continental-ranking';
        this.preTitle = 'Statistics';
        this.headerImage = '../../../modules/custom/wa_angular/app/assets/images/banner-world-ranking.jpg';
        this.titleService.setTitle('Continental Ranking | World Archery');
        break;
      case 'world-ranking':
        this.title = 'SanlidaWorldRanking';
        this.preTitle = 'Statistics';
        this.headerImage = '../../../modules/custom/wa_angular/app/assets/images/banner-world-ranking.jpg';
        this.titleService.setTitle('Sanlida World Ranking | World Archery');
        break;
      case 'world-cup-ranking':
        this.title = 'WorldCupRanking';
        this.preTitle = 'Statistics';
        this.headerImage = '../../../modules/custom/wa_angular/app/assets/images/banner-world-ranking.jpg';
        this.titleService.setTitle('World Cup Ranking | World Archery');

        break;
      case 'indoor-elite-ranking':
        this.title = 'Elite ranking';
        this.preTitle = 'Indoor World Series';
        this.headerImage = '../../../modules/custom/wa_angular/app/assets/images/indoor-series/banner.jpg';
        this.titleService.setTitle('Elite ranking | World Archery');

        break;
      case 'prize-precision':
        this.preTitle = 'Statistics';
        this.title = 'Prizeforprecision';
        this.headerImage = '../../../modules/custom/wa_angular/app/assets/images/longines-banner.jpg';
        this.titleService.setTitle('Prize for Precision | World Archery');

        break;
      case 'prix-precision':
        this.preTitle = 'Statistics';
        this.title = 'Prizeforprecision';
        this.headerImage = '../../../modules/custom/wa_angular/app/assets/images/longines-banner.jpg';
        this.titleService.setTitle('Prix de la Précision | World Archery');

        break;
      case 'classement-mondial':
        this.title = 'SanlidaWorldRanking';
        this.preTitle = 'Statistics';
        this.headerImage = '../../../modules/custom/wa_angular/app/assets/images/banner-world-ranking.jpg';
        this.titleService.setTitle('Classement mondial Sanlida | World Archery');

        break;
      case 'classements-coupe-du-monde':
        this.title = 'WorldCupRanking';
        this.preTitle = 'Statistics';
        this.headerImage = '../../../modules/custom/wa_angular/app/assets/images/banner-world-ranking.jpg';
        this.titleService.setTitle('Classements Coupe du Monde | World Archery');

        break;

    }
  }

  /**
   * {@inheritdoc}
   *
   * @memberof BootstrapRankingTabsComponent
   */
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.subscriptions.push(this.router.events.pipe(
      filter(e => e instanceof NavigationStart),
    ).subscribe((next: NavigationStart) => {
      const routes = next.url.split('?')[0].split('/');
      const lastSegment = this.getTranslatedRoutes(routes[routes.length - 1]);
      this.manageHeaderChanges(lastSegment);

    }));
  }

  /**
   * Method for get the translated route.
   *
   * @param {string} route the route name.
   * @returns
   * @memberof BootstrapRankingTabsComponent
   */
  getTranslatedRoutes(route: string) {
    let lang = LoadDrupalLangService.getRawLang();
    switch (route) {
      case 'continental-ranking':
        return 'continental-ranking';
      case 'world-ranking':
        return lang === 'en' ? 'world-ranking' : 'classement-mondial'
      case 'world-cup-ranking':
        return lang === 'en' ? 'world-cup-ranking' : 'classements-coupe-du-monde'
      case 'events/indoor/elite-ranking':
        return lang === 'en' ? 'events/indoor/elite-ranking' : '/fr/events/indoor/elite-ranking'
      case 'prize-precision':
        return lang === 'en' ? 'prize-precision' : 'prix-precision'
      case 'classement-mondial':
          return lang === 'fr' ? 'classement-mondial' : 'world-ranking';
      case 'classements-coupe-du-monde':
          return lang === 'fr' ?  'classements-coupe-du-monde' : 'world-cup-ranking';
      case 'events/indoor/elite-ranking':
          return lang === 'fr' ? 'events/indoor/elite-ranking' : 'events/indoor/elite-ranking'
      case 'prix-precision':
          return lang === 'fr' ? 'prix-precision' : 'prize-precision'
    }
  }

}
